// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__MIhhh","tabsList":"tabs_tabsList__qdAy7","tab":"tabs_tab__buanL","active":"tabs_active__psD02","dark":"tabs_dark__4FEKS"};